( function( $ ){

    $( '.location-links-modal-dropdown' ).on( 'change', function( e ){

        let location_id = $( this ).val();
        console.log( location_id );
        $( '.links-block.active' ).removeClass( 'active' );
        $( '.links-block[data-id="'+ location_id +'"' ).addClass( 'active' );

    });

})( jQuery );